export default [
  {
    "name": "AVX Good Morning",
    "roast": "S",
    "notes": [
      "csokolade"
    ],
    "lastSeen": "2026-03-27T09:29:17.280Z"
  },
  {
    "name": "AVX Bronze",
    "roast": "S",
    "notes": [
      "etcsokolade",
      "mogyoro",
      "kakao"
    ],
    "desc": "Étcsokoládé, pörkölt mogyoró és kakaó.",
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "Automata Blend 70/30",
    "roast": "S",
    "notes": [
      "kakao",
      "etcsokolade"
    ],
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "La Dolce Vita 80/20-as Blend",
    "roast": "S",
    "notes": [
      "etcsokolade",
      "kakao"
    ],
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "AVX Silver",
    "roast": "KS",
    "notes": [
      "mogyoro",
      "diofelek",
      "kakao",
      "narancs"
    ],
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "AVX Espresso",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "narancs",
      "kakao"
    ],
    "desc": "Étcsokoládé, vérnarancs és kakaó.",
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "AVX Gold",
    "roast": "KS",
    "notes": [
      "mogyoro",
      "csokolade",
      "gyumolcsos"
    ],
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "AVX 100% Arabica Blend",
    "roast": "KS",
    "notes": [
      "csokolade"
    ],
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "AVX India Malabar Blend",
    "roast": "KS",
    "notes": [
      "fuszerek",
      "dohany"
    ],
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "Béla papa kedvence Blend",
    "roast": "KS",
    "notes": [
      "csokolade",
      "mogyoro",
      "ananasz",
      "eper"
    ],
    "lastSeen": "2026-03-27T09:29:17.281Z"
  },
  {
    "name": "AVX Choco & Orange Blend",
    "roast": "KV",
    "notes": [
      "etcsokolade",
      "narancs"
    ],
    "lastSeen": "2025-08-29T07:24:12.587Z"
  },
  {
    "name": "Bécsi Keringő Limited Edition Blend",
    "roast": "KV",
    "notes": [
      "gyumolcsos"
    ],
    "desc": "Csonthéjas gyümölcsök."
  },
  {
    "name": "Brazil Bom Dia Signature",
    "roast": "KS",
    "notes": [
      "cseresznye",
      "csokolade",
      "mogyoro",
      "mazsola",
      "karamellizalt"
    ],
    "lastSeen": "2026-03-27T09:29:17.282Z"
  },
  {
    "name": "Brazil Carbonic Natural Koffeinmentes",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "kakao",
      "mez"
    ],
    "lastSeen": "2026-03-27T09:29:17.282Z"
  },
  {
    "name": "Brazil Fazenda Da Lagoa CO2 Footprint Natural Specialty 84p",
    "roast": "KV",
    "notes": [
      "etcsokolade",
      "diofelek"
    ]
  },
  {
    "name": "Brazil Fazenda Dona Nenem Specialty 84p",
    "roast": "KV",
    "notes": [
      "edes",
      "savanyu"
    ],
    "desc": "Ez a kávé édes, telt testű, enyhe savú és nagyon jól kiegyensúlyozott.",
    "lastSeen": "2026-03-27T09:29:17.282Z"
  },
  {
    "name": "Brazil Fazenda do Lobo Mundo Novo Anaerobic Specialty 86p",
    "roast": "KV",
    "notes": [
      "etcsokolade",
      "diofelek"
    ]
  },
  {
    "name": "Brazil Fazenda Miaki Yellow Bourbon ",
    "roast": "KS",
    "notes": [
      "mogyoro",
      "csokolade",
      "narancs"
    ],
    "lastSeen": "2026-03-27T09:29:17.282Z"
  },
  {
    "name": "Brazil Fazenda Rainha Yellow Bourbon Specialty 86p",
    "roast": "KS",
    "notes": [
      "fekete-tea",
      "diofelek",
      "mogyoro"
    ],
    "desc": "Tea, dió, mogyoró vaj."
  },
  {
    "name": "Brazil Fazenda Sertao Yellow Bourbon Specialty 84p",
    "roast": "KS",
    "notes": [
      "edes",
      "egyeb-gyumolcs",
      "csokolade"
    ],
    "desc": "Jó édesség, sima test, leníz gyümölcsök és csokoládé."
  },
  {
    "name": "Brazil Santos",
    "roast": "KS",
    "notes": [
      "diofelek",
      "kakao",
      "etcsokolade"
    ],
    "lastSeen": "2026-03-27T09:29:17.283Z"
  },
  {
    "name": "Brazil Santos CO2 Koffeinmentes",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "kakao",
      "mez"
    ],
    "lastSeen": "2025-08-11T05:25:25.208Z"
  },
  {
    "name": "Brazil natural Obata Fazenda da Lagoa Specialty 84p",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "diofelek"
    ]
  },
  {
    "name": "Brazil Mogiana Scr 17/18 fine cup",
    "roast": "KS",
    "notes": [
      "edes",
      "savanyu",
      "csokolade",
      "diofelek",
      "gyumolcsos"
    ],
    "desc": "Enyhén édes illatú, enyhe savakkal, telt és kerek testtel rendelkezik, csokoládé, dió és gyümölcs ízekkel."
  },
  {
    "name": "Colombia Carbonic Natural Koffeinmentes",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "kakao",
      "mez",
      "narancs"
    ],
    "lastSeen": "2025-11-07T15:15:26.541Z"
  },
  {
    "name": "Colombia Excelso CO2 Koffeinmentes",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "kakao",
      "mez",
      "narancs"
    ],
    "lastSeen": "2025-06-14T06:59:31.656Z"
  },
  {
    "name": "Colombia Geisha Cinnamon Cauca Excelso EP Finca El Paraiso",
    "roast": "V",
    "notes": [
      "fekete-tea",
      "edes"
    ],
    "desc": "Zöld tea. Ez a kávé almasavú, közepesen édes, intenzív, telt testű.",
    "lastSeen": "2026-01-18T11:02:33.236Z"
  },
  {
    "name": "Colombia Geisha Lychee Cauca Excelso EP Finca El Paraiso.",
    "roast": "V",
    "notes": [
      "egyeb-gyumolcs"
    ],
    "desc": "Trópusi licsi"
  },
  {
    "name": "Colombia Supremo Sofia",
    "roast": "KS",
    "notes": [
      "csokolade",
      "grapefruit"
    ],
    "lastSeen": "2026-02-27T14:02:16.438Z"
  },
  {
    "name": "Costa Rica Palmichal Micromill Honey Natural",
    "roast": "KS",
    "notes": [
      "oszibarack",
      "citrus"
    ],
    "desc": "őszibarack, mandaran gyümölcs ízek.",
    "lastSeen": "2025-08-04T06:02:26.856Z"
  },
  {
    "name": "Costa Rica SHB EP Washed",
    "roast": "KS",
    "notes": [
      "piritott",
      "diofelek",
      "citrus",
      "bors"
    ],
    "desc": "Pörkölt gesztenye, citrusos savassággal és némi borsos fűszerességgel kiegészítve."
  },
  {
    "name": "El Salvador Apaneca Pacamara washed Specialty 85p",
    "roast": "KS",
    "notes": [
      "csokolade",
      "diofelek"
    ],
    "lastSeen": "2026-02-27T14:02:16.439Z"
  },
  {
    "name": "El Salvador Los Naranjos Valley Red Bourbon natural Specialty 87p",
    "roast": "KS",
    "notes": [
      "aszalt-gyumolcs",
      "kakao"
    ]
  },
  {
    "name": "Ethiopia Sidamo Aleta Wondo",
    "roast": "V",
    "notes": [
      "fekete-tea",
      "citrom"
    ],
    "desc": "Citromos fekete teára hasonlít. Közepesen testes kávé.",
    "lastSeen": "2026-03-27T09:29:17.284Z"
  },
  {
    "name": "Ethiopia Sidamo GR1 Shantawene Bombe natural",
    "roast": "V",
    "notes": [
      "gyumolcsos",
      "viragos",
      "oszibarack",
      "fekete-tea"
    ],
    "desc": "Komplex, gyümölcsös. A florális ízjegyek dominálnak, némi őszibarak, fekete tea."
  },
  {
    "name": "Ethiopia Sidamo GR1 Shantawene natural",
    "roast": "V",
    "notes": [
      "egyeb-gyumolcs",
      "citrus",
      "viragos"
    ],
    "desc": "Trópusi gyümölcsök, citrusfélék és virágos jegyek.",
    "lastSeen": "2025-07-11T14:43:38.740Z"
  },
  {
    "name": "Ethiopia washed Limu",
    "roast": "V",
    "notes": [
      "gyumolcsos",
      "viragos",
      "narancs"
    ],
    "desc": "Komplex, gyümölcsös. A florális ízjegyek dominálnak, némi narancsos savassággal és nugátos ízzel.",
    "lastSeen": "2025-11-21T07:37:02.185Z"
  },
  {
    "name": "Ethiopia washed Yirgacheffe",
    "roast": "V",
    "notes": [
      "gyumolcsos",
      "viragos",
      "narancs"
    ],
    "desc": "Komplex, gyümölcsös. A florális ízjegyek dominálnak, némi narancsos savassággal és nugátos ízzel.",
    "lastSeen": "2026-03-27T09:29:17.285Z"
  },
  {
    "name": "Ethiopia washed Yirgacheffe Kochere",
    "roast": "V",
    "notes": [
      "gyumolcsos",
      "viragos",
      "narancs"
    ],
    "desc": "Komplex, gyümölcsös. A florális ízjegyek dominálnak, némi narancsos savassággal és nugátos ízzel.",
    "lastSeen": "2026-03-06T16:50:01.294Z"
  },
  {
    "name": "Guatemala SHB EP Catuai Finca El Gigante Specialty 84p",
    "roast": "KS",
    "notes": [
      "egyeb-gyumolcs"
    ],
    "desc": "maracuja és keksz"
  },
  {
    "name": "Guatemala SHB EP Specialty 84p",
    "roast": "KS",
    "notes": [
      "fekete-tea",
      "aszalt-gyumolcs"
    ]
  },
  {
    "name": "Honduras Cauful Organic Specialty 82p",
    "roast": "KS",
    "notes": [
      "csokolade",
      "edes",
      "citrus",
      "gyogynoveny"
    ],
    "desc": "Tejcsokoládé, édes briós, citrusfélék, vajas és gyógynövényes; sima test."
  },
  {
    "name": "Honduras Pacamara Hacienda Montecristo Specialty 86p",
    "roast": "KS",
    "notes": [
      "csokolade",
      "diofelek",
      "egyeb-gyumolcs",
      "citrom"
    ],
    "desc": "Íze csokoládé, dió és trópusi gyümölcs. Citromsav, sima test."
  },
  {
    "name": "India Plantation AA",
    "roast": "KS",
    "notes": [
      "csokolade",
      "mogyoro",
      "edes"
    ],
    "desc": "Tejcsokoládé, mogyoró, keksz. Édes, közepesen testes és alacsony savasság.",
    "lastSeen": "2026-03-27T09:29:17.285Z"
  },
  {
    "name": "India Robusta Cherry AA",
    "roast": "S",
    "notes": [
      "fuszerek",
      "etcsokolade",
      "magvak"
    ],
    "lastSeen": "2026-03-27T09:29:17.285Z"
  },
  {
    "name": "India Monsooned Malabar AA",
    "roast": "KS",
    "notes": [
      "fuszerek",
      "dohany"
    ],
    "lastSeen": "2026-03-27T09:29:17.285Z"
  },
  {
    "name": "Kenya AA Plus",
    "roast": "V",
    "notes": [
      "citrom",
      "egyeb-gyumolcs",
      "afonya"
    ],
    "desc": "Érett citrom, kajszibarack és áfonya.",
    "lastSeen": "2026-03-06T16:50:01.295Z"
  },
  {
    "name": "Nicaragua Maragogype Laguna Verde Specialty-87p",
    "roast": "KV",
    "notes": [
      "gyumolcsos",
      "edes",
      "alma"
    ],
    "desc": "Csonthéjas gyümölcsök, cukornád és alma ízek",
    "lastSeen": "2025-10-13T05:29:57.286Z"
  },
  {
    "name": "Nicaragua SHG El Limoncillo Estate Specialty-84p",
    "roast": "KS",
    "notes": [
      "egyeb-gyumolcs",
      "alkohol",
      "narancs"
    ],
    "desc": "Passiógyümölcs ízei, rum, és narancshéj."
  },
  {
    "name": "Mexico Maragogype Superior washed Specialty-88p",
    "roast": "KV",
    "notes": [
      "csokolade",
      "oszibarack",
      "citrom"
    ],
    "desc": "Tejcsokoládé, Sárgabarack, Citrom",
    "lastSeen": "2026-02-20T15:48:35.838Z"
  },
  {
    "name": "Tanzania AA Utengule Estate Honey Specialty 86p",
    "roast": "KV",
    "notes": [
      "bogyos-gyumolcs",
      "mez",
      "csokolade"
    ],
    "lastSeen": "2026-03-27T09:29:17.286Z"
  },
  {
    "name": "Tanzania Ngila Estate Peak Season Special Kent Specialty 88p",
    "roast": "KV",
    "notes": [
      "grapefruit",
      "citrus",
      "fekete-tea"
    ],
    "lastSeen": "2025-12-12T07:49:20.078Z"
  },
  {
    "name": "Tanzania Mwankumbi Specialty 87p",
    "roast": "KV",
    "notes": [
      "citrus",
      "cseresznye",
      "csokolade",
      "karamellizalt",
      "melasz"
    ],
    "desc": "Mandarin, fekete cseresznye, csokoládé szirup, karamell, melasz; élénk savasság, selymes test."
  },
  {
    "name": "Panama El Hortigal Estate Specialty-88p",
    "roast": "KV",
    "notes": [
      "gyumolcsos"
    ],
    "desc": "Csonthéjas gyümölcsök.",
    "lastSeen": "2026-02-27T14:02:16.442Z"
  },
  {
    "name": "Peru Carbonic Natural Koffeinmentes",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "kakao",
      "mez",
      "narancs"
    ],
    "lastSeen": "2025-12-12T07:49:20.078Z"
  },
  {
    "name": "Peru Cemcavir Geisha Finca Mariposa",
    "roast": "V",
    "notes": [
      "cseresznye"
    ],
    "desc": "Keksz, cseresznye."
  },
  {
    "name": "Peru Cemcavir Geisha Finca La Esperanza",
    "roast": "KV",
    "notes": [
      "csokolade",
      "cseresznye",
      "aszalt-gyumolcs",
      "alkohol"
    ],
    "desc": "Csokoládé, cseresznye, szárított gyümölcsök és rum.",
    "lastSeen": "2025-08-11T05:25:25.213Z"
  },
  {
    "name": "Peru Cemcavir Geisha Anaerobic",
    "roast": "V",
    "notes": [
      "csokolade",
      "cseresznye",
      "aszalt-gyumolcs",
      "alkohol"
    ],
    "desc": "Csokoládé, cseresznye, szárított gyümölcsök és rum.",
    "lastSeen": "2025-07-24T15:09:04.352Z"
  },
  {
    "name": "PNG Washed Arabica Korofeigu Grade",
    "roast": "KS",
    "notes": [
      "karamellizalt",
      "vanilia",
      "csokolade"
    ],
    "lastSeen": "2025-05-31T07:44:58.687Z"
  },
  {
    "name": "Indonesia Toraja Kalossi Gr.1",
    "roast": "KS",
    "notes": [
      "gyumolcsos",
      "csokolade"
    ],
    "lastSeen": "2025-06-30T16:07:58.343Z"
  },
  {
    "name": "Ecuador Vilcabamba Especial de Apecael",
    "roast": "KV",
    "notes": [
      "gyumolcsos"
    ],
    "desc": "csonthéjas gyömölcsök",
    "lastSeen": "2025-05-29T06:56:34.253Z"
  },
  {
    "name": "Rwanda washed Sake Womens Coffee Specialty 86p",
    "roast": "KV",
    "notes": [
      "fuszerek",
      "citrus"
    ],
    "desc": "Fűszernövények, mandarin",
    "lastSeen": "2026-02-07T08:06:28.648Z"
  },
  {
    "name": "AVX Diamond",
    "roast": "KS",
    "notes": [
      "mogyoro",
      "csokolade",
      "gyumolcsos"
    ],
    "lastSeen": "2026-03-27T09:29:17.287Z"
  },
  {
    "name": "AVX Jin-Jang Blend",
    "roast": "KS",
    "notes": [
      "csokolade",
      "mogyoro",
      "ananasz",
      "egyeb-gyumolcs"
    ],
    "desc": "Tejcsokoládé, mogyoró, az ananász édességével és trópusi gyümölcsséggel.",
    "lastSeen": "2025-11-07T15:15:26.549Z"
  },
  {
    "name": "Guatemala SHB EP Santa Rosa Specialty 84p",
    "roast": "KS",
    "notes": [
      "fekete-tea",
      "aszalt-gyumolcs"
    ],
    "lastSeen": "2026-03-27T09:29:17.287Z"
  },
  {
    "name": "Nicaragua Red Pacamara El Limoncillo Specialty-88p",
    "roast": "KV",
    "notes": [
      "egyeb-gyumolcs",
      "alkohol",
      "narancs"
    ],
    "desc": "Passiógyümölcs ízei, rum, és narancshéj.",
    "lastSeen": "2026-03-06T16:50:01.300Z"
  },
  {
    "name": "PNG Hai Tambu",
    "roast": "KS",
    "notes": [
      "gyogynoveny",
      "egyeb-gyumolcs",
      "citrus"
    ],
    "desc": "Gyógynövények, fekete ribizli, mandarin",
    "lastSeen": "2026-03-27T09:29:17.287Z"
  },
  {
    "name": "Rwanda Inagagi Specialty 85p",
    "roast": "KV",
    "notes": [
      "gyumolcsos",
      "bogyos-gyumolcs"
    ],
    "desc": "csonthéjas gyümölcsök, bogyók",
    "lastSeen": "2025-09-11T05:27:16.994Z"
  },
  {
    "name": "Brazil Fazenda Rainha Yellow Bourbon pulped natural Specialty 84p",
    "roast": "KS",
    "notes": [
      "diofelek",
      "gyumolcsos"
    ],
    "desc": "Makadám dió, gyömölcsök.",
    "lastSeen": "2025-12-05T16:21:37.372Z"
  },
  {
    "name": "Guatemala SHB EP Huehuetenango Specialty 84p",
    "roast": "KS",
    "notes": [
      "narancs",
      "csokolade"
    ],
    "desc": "Narancs, Tejcsokoládé, Keksz",
    "lastSeen": "2026-02-20T15:48:35.841Z"
  },
  {
    "name": "Brazil Fazenda da Lagoa Specialty 84p",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "diofelek"
    ],
    "lastSeen": "2026-03-27T09:29:17.288Z"
  },
  {
    "name": "Brazil Fazenda Sertao Peaberry Natural Yellow Bourbon",
    "roast": "KS",
    "notes": [
      "edes",
      "gyumolcsos",
      "csokolade"
    ],
    "desc": "Édes gyümölcsök, csokoládé.",
    "lastSeen": "2025-08-04T06:02:26.862Z"
  },
  {
    "name": "Ethiopia Guji Tero Natural",
    "roast": "V",
    "notes": [
      "gyumolcsos",
      "viragos",
      "oszibarack",
      "fekete-tea"
    ],
    "desc": "Komplex, gyümölcsös. A florális ízjegyek dominálnak, némi őszibarak, fekete tea.",
    "lastSeen": "2026-03-06T16:50:01.301Z"
  },
  {
    "name": "Honduras SHG EP Guara Roja Red Honey Specialty 84p",
    "roast": "KS",
    "notes": [
      "gyumolcsos",
      "edes",
      "savanyu"
    ],
    "desc": "Édes és élénk savasság, lédús ízvilágú kávé. Komplex aroma és különleges utóíz.",
    "lastSeen": "2026-03-27T09:29:17.288Z"
  },
  {
    "name": "Nicaragua SHB EP Jinotega Matagalpa Specialty",
    "roast": "KS",
    "notes": [
      "oszibarack",
      "kakao"
    ],
    "desc": "Kajszibarack, őszibarack, kakaó.",
    "lastSeen": "2025-12-12T07:49:20.081Z"
  },
  {
    "name": "India Robusta Monsooned AA Aspinwall",
    "roast": "S",
    "notes": [
      "diofelek",
      "szemes-gabona"
    ],
    "desc": "Pörkölt dió, nugát, gabonafélék",
    "lastSeen": "2026-03-27T09:29:17.288Z"
  },
  {
    "name": "Peru Negrisa Gr1",
    "roast": "KV",
    "notes": [
      "noveny",
      "bogyos-gyumolcs"
    ],
    "desc": "Édes rebarbara , Sötét bogyós gyümölcsök",
    "lastSeen": "2026-03-27T09:29:17.288Z"
  },
  {
    "name": "Costa Rica La Pastora Tarrazu",
    "roast": "KS",
    "notes": [
      "barna-cukor",
      "csokolade",
      "alma",
      "narancs"
    ],
    "lastSeen": "2026-03-27T09:29:17.288Z"
  },
  {
    "name": "Mexico SHG Organic EP Berilo Specialty-84p",
    "roast": "KS",
    "notes": [
      "csokolade",
      "diofelek",
      "karamellizalt",
      "edes",
      "narancs",
      "alma"
    ],
    "desc": "Csokis-diós, karamelles/cane sugar édességgel és narancs-almás savgerinccel.",
    "lastSeen": "2026-03-27T09:29:17.289Z"
  },
  {
    "name": "Ethiopia Sidamo GR1 Shantawene washed",
    "roast": "F",
    "notes": [
      "egyeb-gyumolcs",
      "citrus",
      "viragos"
    ],
    "desc": "Trópusi gyümölcsök, citrusfélék és virágos jegyek.",
    "lastSeen": "2026-03-27T09:29:17.289Z"
  },
  {
    "name": "AVX Choco and Orange Blend",
    "roast": "KV",
    "notes": [
      "etcsokolade",
      "narancs"
    ],
    "lastSeen": "2026-02-27T14:02:16.447Z"
  },
  {
    "name": "Kenya AA Jambo Jambo",
    "roast": "V",
    "notes": [
      "bogyos-gyumolcs",
      "citrus",
      "fekete-tea"
    ],
    "desc": "Bogyók, citrusfélék és fekete tea. Lédús, selymes és pezsgő, élénk savassággal.",
    "lastSeen": "2026-03-06T16:50:01.303Z"
  },
  {
    "name": "Nicaragua Mama Mina Red Pacamara Specialty-88p",
    "roast": "KS",
    "notes": [
      "alma",
      "oszibarack",
      "fahej"
    ],
    "desc": "Piros almára, sárgabarackra és egy csipetnyi fahéjra emlékeztet",
    "lastSeen": "2026-03-27T09:29:17.289Z"
  },
  {
    "name": "Nicaragua Natural Robusta",
    "roast": "S",
    "notes": [
      "etcsokolade",
      "dohos-foldes",
      "diofelek",
      "melasz",
      "fekete-tea"
    ],
    "desc": "Étcsokoládé, földes jegyek, dió, melasz, fekete tea",
    "lastSeen": "2026-03-27T09:29:17.289Z"
  },
  {
    "name": "Nicaragua 7777 Limited Edition Blend",
    "roast": "KS",
    "notes": [
      "csokolade"
    ],
    "lastSeen": "2026-03-27T09:29:17.289Z"
  },
  {
    "name": "Ethiopia Natural Guji Buku Abel Gr1. Specialty",
    "roast": "F",
    "notes": [
      "gyumolcsos",
      "diofelek",
      "afonya",
      "mandula",
      "csokolade"
    ],
    "lastSeen": "2025-12-12T07:49:20.084Z"
  },
  {
    "name": "Ethiopia Guji Boku Abel Natural",
    "roast": "F",
    "notes": [
      "gyumolcsos",
      "viragos",
      "oszibarack",
      "fekete-tea"
    ],
    "desc": "Komplex, gyümölcsös. A florális ízjegyek dominálnak, némi őszibarak, fekete tea.",
    "lastSeen": "2026-03-27T09:29:17.289Z"
  },
  {
    "name": "Brazil Maragogype Natural Specialty 87p",
    "roast": "KV",
    "notes": [
      "citrus",
      "grapefruit",
      "viragos",
      "mez",
      "csokolade",
      "karamellizalt"
    ],
    "desc": "Friss citrusos, élénk savasság (citrom, grapefruit jelleg), virágos aromák, mézes édesség (finom, lágy testtel), csokoládés, karamelles vagy gyümölcsös jegyek (területtől függően). Általános karakter: kiegyensúlyozott, elegáns, aromás és nem agresszív.",
    "lastSeen": "2026-03-06T16:50:01.303Z"
  },
  {
    "name": "Bolivia Caranavi Ayni Gr1 washed Bio",
    "roast": "KV",
    "notes": [
      "csokolade",
      "diofelek",
      "citrus"
    ],
    "desc": "Finoman csokoládés és diós jegyek, karamellás édesség, enyhe citrusos savasság, tiszta, kiegyensúlyozott utóíz.",
    "lastSeen": "2026-02-27T14:02:16.448Z"
  },
  {
    "name": "Rio-Mumbai Arabica Blend",
    "roast": "KS",
    "notes": [
      "csokolade",
      "mogyoro",
      "karamellizalt",
      "fuszerek",
      "citrus"
    ],
    "desc": "Csokoládé, mogyoró/nougat, karamell/toffee, háttérben enyhe fűszeresség, és néha egy finom citrusos/gyümölcsös felhang.",
    "lastSeen": "2026-03-27T09:29:17.290Z"
  },
  {
    "name": "Ethiopia Natural Yirgacheffe Chelelektu",
    "roast": "V",
    "notes": [
      "gyumolcsos",
      "viragos",
      "narancs"
    ],
    "desc": "Komplex, gyümölcsös. A florális ízjegyek dominálnak, némi narancsos savassággal és nugátos ízzel.",
    "lastSeen": "2026-03-27T09:29:17.290Z"
  },
  {
    "name": "Colombia Supremo Huila",
    "roast": "KS",
    "notes": [
      "etcsokolade",
      "karamellizalt",
      "mogyoro",
      "diofelek",
      "bogyos-gyumolcs"
    ],
    "desc": "Étcsokoládé, édes karamell és pörkölt mogyoró/dió. Érett bogyós gyümölcsök, szilva, vörös alma, néha pedig citrusos.  Édes, gyakran kakaós vagy finoman fűszeres lecsengés.",
    "lastSeen": "2026-03-27T09:29:17.290Z"
  }
];
